<nav class="navbar navbar-light bg-light static-top">
  <div class="container">
    <a [routerLink]="['/']"
       class="navbar-brand">
      <img alt="Southwestern Family of Companies - Company Stock Plan"
           src="/assets/images/southwestern-logo-splash.png" width="200">
    </a>
    @if (showAdminLink) {
      <div>
        <span class="mt-2 font-weight-bold pointable text-success pe-3"
              [class.text-error]="isAdminOnlyMode$|async"
              (click)="toggleOffline()">
          * @if (isAdminOnlyMode$|async) {
            <span class="text-underline">site offline</span>
          }
          @if ((isAdminOnlyMode$|async)===false) {
            <span class="text-underline">site online</span>
          } *
        </span>
        @if (isShareholdersRoute) {
          <a [routerLink]="['/']"
             class="shadow-sm btn btn-site-primary">Home</a>
        } @else {
          <button (click)="goToShareholders()"
                  class="shadow-sm btn btn-site-primary">Admin</button>
        }
      </div>
    }

  </div>
</nav>

<ng-template app-confirm-simple>
  <app-confirm-modal-component></app-confirm-modal-component>
</ng-template>

